// eslint-disable-next-line react-hooks/rules-of-hooks
import axios from "shared/api/axiosConfig";


export async function getUserCurrentPayments (userType, userId) {
    try {
        // const userType = 'individual';
        const url = `client/payment_logs`

        const body = new FormData()
        body.append('type', userType)
        body.append('userId', userId)

        const response = await axios.post(url, new FormData(), {
            // withCredentials: true,
        });

        if (response) {
            // console.log(response)
        }
    } catch (error) {
        // console.error(error);
    }
};


export async function getUserCurrentCredits  (userType, userId) {
    try {

        const url = `client/credits`

        const body = new FormData()
        body.append('type', userType)
        body.append('userId', userId)

        const response = await axios.post(url, new FormData(), {
            withCredentials: true,
        });

        if (response) {
            // console.log(response)
        }
    } catch (error) {
        // console.error(error);
    }
};

export async function decrementCredits(type, decrementValue) {
    const url = 'client/decrement_credits';
    const data = new FormData();
    data.append('type',type);
    data.append('decrementValue',decrementValue);

    return axios.post(url,data);
}

/**
 * Quota gratuit mensuel de détection — miroir web de `detection_quota_api.dart`
 * (app mobile). 3 vérifications gratuites par mois ET PAR OUTIL, puis débit
 * d'une vérification du solde. Les endpoints backend répondent en JSON clair.
 */
export const DetectionTool = {
    documentAdd: 'document_add',
    documentVerify: 'document_verify',
    identity: 'identity',
};

/** Message unique affiché quand le quota gratuit ET le solde sont épuisés. */
export const NO_VERIFICATION_LEFT =
    "Vous n'avez plus de vérification disponible. Vos 3 vérifications gratuites du mois sont utilisées ; vous pouvez en acheter depuis votre compte.";

const asInt = (v) => (typeof v === 'number' ? Math.trunc(v) : parseInt(v, 10) || 0);

/**
 * Etat du quota du mois : { quota, used, credits, freeRemaining(), canStart() }.
 * Renvoie null si l'appel échoue (l'appelant ne doit alors PAS bloquer l'utilisateur).
 */
export async function loadDetectionQuota(type) {
    try {
        const res = await axios.post('client/detection/quota', { type });
        if (res?.status !== 200 || !res.data) return null;

        const used = res.data.used ?? {};
        const quota = asInt(res.data.quota ?? 3);
        const credits = asInt(res.data.credits);

        return {
            quota,
            credits,
            used: {
                [DetectionTool.documentAdd]: asInt(used[DetectionTool.documentAdd]),
                [DetectionTool.documentVerify]: asInt(used[DetectionTool.documentVerify]),
                [DetectionTool.identity]: asInt(used[DetectionTool.identity]),
            },
            freeRemaining(tool) {
                const rest = quota - asInt(this.used[tool]);
                return Math.min(Math.max(rest, 0), quota);
            },
            canStart(tool) {
                return this.freeRemaining(tool) > 0 || credits > 0;
            },
        };
    } catch (error) {
        return null;
    }
}

/**
 * Garde d'entrée : autorise le lancement d'une opération de détection.
 * Tolérante par choix — si le quota n'est pas joignable, on laisse passer
 * plutôt que de bloquer un utilisateur sur un incident réseau.
 */
export async function canStartDetection(type, tool) {
    const quota = await loadDetectionQuota(type);
    if (!quota) return true;
    return quota.canStart(tool);
}

/**
 * Consomme une opération APRÈS succès : journalise l'usage et, au-delà des
 * 3 gratuites du mois pour cet outil, débite 1 vérification du solde.
 * Best-effort (comme sur mobile) : n'interrompt jamais le parcours.
 */
export async function consumeDetection(type, tool) {
    try {
        await axios.post('client/detection/consume', { type, tool });
    } catch (error) {
        // best-effort : ne bloque jamais le parcours.
    }
}
